import React, { Component } from "react";
import styled from "styled-components";

import NavigationItem from "../NavigationItems/NavigationItem/NavigationItem";
import Divider from "../../Divider/Divider";
// import Modal from "@material-ui/core/Modal";
// import Typography from "@material-ui/core/Typography/Typography";
import { withStyles } from "@material-ui/core";
// import Button from "@material-ui/core/Button";

import ContactUs from "../../Pages/Contact/ContactUs";

const StyledFooter = styled.footer`
  height: 8vh;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  color: #b3b3b3;
  background: white;
  font-size: 10pt;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  margin-top: 2rem;
  box-sizing: border-box;
  z-index: 110;

  @media (max-width: 600px) {
    font-size: 8pt;
  }
`;

const StyledNavbarItem = styled(NavigationItem)`
  && {
    font-size: 12px;
    color: #b3b3b3;

    @media (max-width: 600px) {
      font-size: 8pt;
      padding: 1rem;
    }

    @media (max-width: 500px) {
      font-size: 7pt;
    }

    @media (max-width: 400px) {
      font-size: 6pt;
    }
  }
`;

const FooterNavigation = styled.div`
  display: flex;
  text-transform: uppercase;

  @media (max-width: 600px) {
    font-size: 8pt;
  }

  @media (max-width: 500px) {
    font-size: 7pt;
  }

  @media (max-width: 400px) {
    font-size: 6pt;
  }
`;

const StyledDivider = styled(Divider)`
  @media (max-width: 600px) {
    padding: 0 1rem;
  }

  @media (max-width: 500px) {
    display: none;
  }
`;

// const rand = () => {
//   return Math.round(Math.random() * 20) - 10;
// };

// const getModalStyle = () => {
//   const top = 50 + rand();
//   const left = 50 + rand();
//
//   return {
//     top: `${top}%`,
//     left: `${left}%`,
//     transform: `translate(-${top}%, -${left}%)`
//   };
// };

const styles = theme => ({
  paper: {
    position: "absolute",
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4
  }
});

class Footer extends Component {
  state = {
    open: false
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    //const { classes } = this.props;

    return (
      <StyledFooter>
        <div>&copy; TóMSTUND {new Date().getFullYear()}</div>
        <FooterNavigation>
          <ContactUs />
          <StyledDivider>|</StyledDivider>
          <StyledNavbarItem link="/contact">Legal Notice</StyledNavbarItem>
          <StyledDivider>|</StyledDivider>
          <StyledNavbarItem link="/privacy">Privacy Policy</StyledNavbarItem>
        </FooterNavigation>
      </StyledFooter>
    );
  }
}

const FooterWrapped = withStyles(styles)(Footer);

export default FooterWrapped;



// WEBPACK FOOTER //
// ./src/components/Navgation/Footer/Footer.js